module.exports = __webpack_public_path__ + "img/reaction18.9da793c2.png";